import MaintenanceModeAlert from '@components/maintenanceModeAlert';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/map')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <MaintenanceModeAlert m="xs" />
      <Outlet />
    </>
  );
}
